module.exports = "https://s.pinimg.com/webapp/style/images/IT@2x-69510950.png";